import { Card } from 'react-bootstrap';

/** Turns the accent colour into a matching soft background for the icon tile. */
function soften(color) {
  if (color.startsWith('var(')) return 'var(--clinic-primary-soft)';
  return `color-mix(in srgb, ${color} 14%, white)`;
}

export default function StatCard({ label, value, icon, color = 'var(--clinic-primary)', hint }) {
  return (
    <Card className="stat-card h-100" style={{ '--stat-color': color, '--stat-soft': soften(color) }}>
      <Card.Body>
        {icon ? (
          <span className="stat-icon">
            <i className={`bi ${icon}`} />
          </span>
        ) : null}
        <div className="min-w-0">
          <div className="stat-value">{value}</div>
          <div className="stat-label">{label}</div>
          {hint ? <div className="small text-muted mt-1">{hint}</div> : null}
        </div>
      </Card.Body>
    </Card>
  );
}
